'use strict';

/**
 * Webinar Card Accordion based on https://www.w3.org/WAI/ARIA/apg/patterns/accordion/examples/accordion/
 */
class WebinarCardAccordion {
	constructor(domNode) {
		this.rootEl = domNode;
		this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

		const controlsId = this.buttonEl.getAttribute('aria-controls');
		this.contentEl = document.getElementById(controlsId);

		this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

		this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
	}

	onButtonClick() {
		this.toggle(!this.open);
	}

	toggle(open) {
		if (open === this.open) {
			return;
		}

		this.open = open;

		this.buttonEl.setAttribute('aria-expanded', `${open}`);
		if (open) {
			this.contentEl.removeAttribute('hidden');
			requestAnimationFrame(() => {
				this.contentEl.style.maxHeight = this.contentEl.scrollHeight + 'px';
			});
		} else {
			requestAnimationFrame(() => {
				this.contentEl.style.maxHeight = '0';
			});
			if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
				// transionend won't fire so hide immediately
				this.contentEl.setAttribute('hidden', '');
			} else {
				const contentEl = this.contentEl;
				this.contentEl.addEventListener('transitionend', function handler() {
					contentEl.setAttribute('hidden', '');
					contentEl.removeEventListener('transitionend', handler);
				});
			}
		}
	}
}

// init accordions
const accordions = document.querySelectorAll('.webinar-card-accordion');
accordions.forEach((accordionEl) => {
	new WebinarCardAccordion(accordionEl);
});
